import React from 'react'

import { Text, TextName } from 'sdk/text/Text'
import GradientOutlineGridBackgroundCard from 'components/gradient-outline-grid-background-card/GradientOutlineGridBackgroundCard'
import dataStorageIcon from 'shared/assets/icons/data-storage.svg'
import lightningIcon from 'shared/assets/icons/lightning-monochrome.svg'
import wireIcon from 'shared/assets/icons/wire.svg'
import broadcastIcon from 'shared/assets/icons/broadcast.svg'

import type { SoundscapeTextCardCmsContent } from 'core/services/cms/interfaces'

import styles from './CyberBuckFeatureCards.module.scss'

interface CyberBuckFeatureCardsProps {
  cards: SoundscapeTextCardCmsContent[]
}

const CARD_ICONS = [dataStorageIcon, lightningIcon, wireIcon, broadcastIcon]

const CyberBuckFeatureCards: React.FC<CyberBuckFeatureCardsProps> = ({ cards }) => {
  return (
    <div className={styles.cardsContainer}>
      {cards.map((card, index) => (
        <GradientOutlineGridBackgroundCard key={index} className={styles.card}>
          <div className={styles.cardContent}>
            <img src={CARD_ICONS[index]} alt="" className={styles.cardIcon} />
            <Text type={TextName.Text}>{card.text}</Text>
          </div>
        </GradientOutlineGridBackgroundCard>
      ))}
    </div>
  )
}

export default CyberBuckFeatureCards
